const _api = {
  maps: {
    Animation: class Animation { },
    LatLng: function (lat: any, lng: any) {
      return {
        latitude: parseFloat(lat),
        longitude: parseFloat(lng),

        lat: function () { return this.latitude; },
        lng: function () { return this.longitude; },
        toJSON: function () { return JSON.stringify(this); },
      };
    },
    LatLngBounds: function (ne: any, sw: any) {
      return {
        getSouthWest: function () { return sw; },
        getNorthEast: function () { return ne; }
      };
    },
    OverlayView: () => {},
    InfoWindow: class InfoWindow {
      addListener() {}
      open() {}
      close() {}
    },
    Marker: class Marker {
      thisIsIt = 12345;
      setMap() {}
      addListener() {}
      setPosition() {}
      setDraggable() {}
    },
    MarkerImage: () => {},
    Map: class GoogleMap {
      setOptions() {}
      setCenter() {}
      getCenter() {}
      addListener() {}
      panTo() {}
    },
    Point: () => {},
    Size: class Size { },
    Geocoder: class Geocoder {
      geocode() {}
    },

    event: {
      addListener: () => {},
      trigger: () => {},
      clearInstanceListeners: () => {}
    },

    places: {
      Autocomplete: class Autocomplete { }
    }
  }
};

export const MockGoogleMapsApi = new class {
  api = _api;

  install() {
    window['google'] = this.api as any;
  }
};
